import { render, staticRenderFns } from "./DetailCosting.vue?vue&type=template&id=5cd17929"
import script from "./DetailCosting.vue?vue&type=script&lang=js"
export * from "./DetailCosting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports